import { motion } from 'motion/react';
import { ArrowRight, Braces, Check, Network, Play, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { useAuth } from '../app/AuthContext';

export function LandingPage() {
  const { enterDemo } = useAuth();
  return (
    <div className="landing">
      <nav className="landing-nav">
        <Logo />
        <div><Link className="nav-login" to="/login">Sign in</Link><Link className="button primary compact" to="/register">Start my plan <ArrowRight size={16} /></Link></div>
      </nav>
      <main>
        <section className="hero">
          <div className="hero-copy">
            <motion.div className="hero-tag" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}><Sparkles size={14} /> Your interview execution system</motion.div>
            <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: .08 }}>Know your ETA.<br /><em>Earn your offer.</em></motion.h1>
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: .18 }}>Turn interview ambition into a measurable 60-day plan. Master DSA, visualize system design, track every interview, and always know the next move between you and the offer.</motion.p>
            <motion.div className="hero-actions" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: .25 }}>
              <Link className="button primary large" to="/register">Start my 60-day ETA <ArrowRight size={19} /></Link>
              <button className="button ghost large" onClick={enterDemo}><Play size={17} fill="currentColor" /> Explore the demo</button>
            </motion.div>
            <div className="hero-proof"><span><Check size={15} /> Complete 60-day system</span><span><Check size={15} /> Progress and interviews synced</span><span><Check size={15} /> Built to finish</span></div>
          </div>
          <motion.div className="hero-visual" initial={{ opacity: 0, x: 50, rotate: 2 }} animate={{ opacity: 1, x: 0, rotate: 0 }} transition={{ duration: .8, ease: 'easeOut' }}>
            <div className="preview-top"><span>Today’s focus</span><b>Day 21 / 60</b></div>
            <div className="preview-title"><div className="topic-icon purple"><Network /></div><div><span>ADVANCED DSA</span><h3>Topological Sort</h3></div></div>
            <div className="mini-flow"><i>A</i><b>→</b><i className="active">B</i><b>→</b><i>C</i><b>→</b><i>D</i></div>
            <div className="preview-progress"><span><b>2</b> of 3 tasks</span><div><i /></div></div>
            <div className="preview-code"><header><span /><span /><span /><small>solution.ts</small></header><pre><code><b>const</b> indegree = <em>new</em> Map();{`\n`}<span>for</span> (const node of graph) {'{'}{`\n`}  <i>// process dependencies</i>{`\n`}{'}'}</code></pre></div>
            <div className="floating-streak"><span>🔥</span><div><b>12</b><small>day streak</small></div></div>
          </motion.div>
        </section>
        <section className="landing-features">
          <article><Braces /><h3>See the code think</h3><p>Step through algorithms line by line while data structures animate beside them.</p></article>
          <article><Network /><h3>Watch systems flow</h3><p>Play architecture diagrams from request to storage, with every tradeoff explained.</p></article>
          <article><Sparkles /><h3>See your ETA shrink</h3><p>Streaks, milestones, interview tracking, and a visible path turn preparation into forward motion.</p></article>
        </section>
      </main>
    </div>
  );
}
